<script setup>
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import SearchResultSection from './SearchResultSection.vue';
import SearchResultWebProductItem from './SearchResultWebProductItem.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  products: { type: Array, default: () => [] },
  query: { type: String, default: '' },
  isFetching: { type: Boolean, default: false },
  showTitle: { type: Boolean, default: true },
});

const router = useRouter();
const { t } = useI18n();

const openProductsList = query => {
  router.push({
    name: 'web_order_products',
    query: { q: query, page: '1' },
  });
};
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.WEB_PRODUCTS')"
    :empty="!products.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
  >
    <ul v-if="products.length" class="list-none space-y-3">
      <li v-for="product in products" :key="product.id">
        <SearchResultWebProductItem :product="product" />
      </li>
    </ul>
    <NextButton
      v-if="products.length && query"
      class="mt-3"
      :label="t('SEARCH.VIEW_IN_PRODUCTS_LIST')"
      icon="i-lucide-list"
      slate
      sm
      outline
      @click="openProductsList(query)"
    />
  </SearchResultSection>
</template>
